import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jiedao",
  "use": "icon-jiedao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jiedao\"><defs><style type=\"text/css\"></style></defs><path d=\"M372.363636 930.909091h558.545455V349.090909h-162.909091v217.390546A139.636364 139.636364 0 1 1 589.754182 744.727273H372.363636v186.181818z m-93.090909 0v-186.181818H93.090909v186.181818h186.181818z m0-279.272727v-186.181819H186.181818v-93.090909h213.457455l116.363636-116.363636H674.909091V93.090909h93.090909v162.909091h162.909091V93.090909H93.090909v558.545455h186.181818z m93.090909 0h217.390546A140.032 140.032 0 0 1 674.909091 566.481455V349.090909h-120.366546l-116.363636 116.363636H372.363636v186.181819zM0 0h1024v1024H0V0z m721.454545 744.727273a46.545455 46.545455 0 1 0 0-93.090909 46.545455 46.545455 0 0 0 0 93.090909z\" fill=\"#ffffff\" p-id=\"2021\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jiedao.svg
// module id = /LpQ
// module chunks = 22